import { Component, OnInit } from '@angular/core';
import { RolJuegosService } from 'src/app/services/roljuegos.service';
import { RegistroService } from 'src/app/services/registro.service';

const MESES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
const DIAS = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];

@Component({
  selector: 'app-calendario',
  templateUrl: './calendario.component.html',
  styleUrls: ['./calendario.component.css']
})
export class CalendarioComponent implements OnInit {

  Jornadas: any[] = [];
  Categorias: any[] = [];
  Partidos: any[] = [];

  jornadaIndex = -1;
  categoriaID = 0;
  jornadaActualID = 0;
  cargando = false;
  placeholderEquipo = './assets/equipos/placeholder-equipo.png';

  constructor(
    private roljuegos_service: RolJuegosService,
    private registro_service: RegistroService
  ) { }

  ngOnInit(): void {
    this.obtenerCategorias();
  }

  onLogoError(event: any): void {
    if (event && event.target && String(event.target.src).indexOf('placeholder-equipo') === -1) {
      event.target.src = this.placeholderEquipo;
    }
  }

  get jornadaSeleccionada(): any {
    return this.jornadaIndex >= 0 ? this.Jornadas[this.jornadaIndex] : null;
  }

  get esJornadaActual(): boolean {
    const jor = this.jornadaSeleccionada;
    return jor ? +jor.JornadaID === this.jornadaActualID : false;
  }

  obtenerCategorias(): void {
    this.registro_service.catalogoCategorias()
      .subscribe((object: any) => {
        if (object.ok) {
          this.Categorias = object.data;
          if (this.Categorias.length > 0) {
            this.categoriaID = +this.Categorias[0].CategoriaID;
          }
        }
        this.obtenerJornadaActual();
      });
  }

  obtenerJornadaActual(): void {
    this.roljuegos_service.obtenerJornadaActivo()
      .subscribe((object: any) => {
        if (object.ok && object.data.length > 0) {
          this.jornadaActualID = +object.data[0].JornadaID;
        }
        this.obtenerJornadas();
      });
  }

  obtenerJornadas(): void {
    this.roljuegos_service.obtenerJornadas()
      .subscribe((object: any) => {
        if (object.ok) {
          this.Jornadas = object.data;
          this.jornadaIndex = this.Jornadas.findIndex((jor: any) => +jor.JornadaID === this.jornadaActualID);
          if (this.jornadaIndex === -1 && this.Jornadas.length > 0) {
            this.jornadaIndex = 0;
          }
          this.buscarPartidos();
        }
      });
  }

  buscarPartidos(): void {
    const jor = this.jornadaSeleccionada;
    if (!jor || !this.categoriaID) { return; }
    const json = {
      JornadaID: +jor.JornadaID,
      CategoriaID: +this.categoriaID,
      InscripcionID: 0
    };
    this.cargando = true;
    this.Partidos = [];
    this.roljuegos_service.obtenerResultados(json)
      .subscribe((object: any) => {
        this.cargando = false;
        if (object.ok) {
          this.Partidos = (object.data || []).map((partido: any) => this.prepararPartido(partido));
        }
      }, () => {
        this.cargando = false;
      });
  }

  seleccionarCategoria(id: any): void {
    this.categoriaID = +id;
    this.buscarPartidos();
  }

  seleccionarJornada(indice: any): void {
    this.jornadaIndex = +indice;
    this.buscarPartidos();
  }

  jornadaAnterior(): void {
    if (this.jornadaIndex > 0) {
      this.jornadaIndex--;
      this.buscarPartidos();
    }
  }

  jornadaSiguiente(): void {
    if (this.jornadaIndex < this.Jornadas.length - 1) {
      this.jornadaIndex++;
      this.buscarPartidos();
    }
  }

  formatearFechaLarga(fecha: string): string {
    const f = this.parsearFecha(fecha);
    if (!f) { return ''; }
    return DIAS[f.getDay()] + ' ' + f.getDate() + ' de ' + MESES[f.getMonth()] + ' de ' + f.getFullYear();
  }

  formatearFechaCorta(fecha: string): string {
    const f = this.parsearFecha(fecha);
    if (!f) { return ''; }
    return f.getDate() + ' ' + MESES[f.getMonth()].slice(0, 3) + ' ' + f.getFullYear();
  }

  private prepararPartido(partido: any): any {
    const equipo1 = this.prepararEquipo(partido.equipo_1);
    const equipo2 = this.prepararEquipo(partido.equipo_2);
    return {
      categoria: partido.categoria,
      ubicacion: partido.ubicacion,
      cronicas: partido.cronicas,
      equipo_1: equipo1,
      equipo_2: equipo2,
      finalizado: equipo1.carreras !== null || equipo2.carreras !== null
    };
  }

  private prepararEquipo(equipo: any): any {
    const tieneCarreras = equipo && equipo.carreras !== null && equipo.carreras !== undefined && equipo.carreras !== '';
    const logo = equipo && equipo.logo ? String(equipo.logo).replace('http://', 'https://') : '';
    return {
      equipo: equipo && equipo.equipo ? equipo.equipo : '',
      logo: logo,
      carreras: tieneCarreras ? +equipo.carreras : null,
      win: equipo ? !!equipo.win : false,
      sinLogo: logo === ''
    };
  }

  private parsearFecha(fecha: string): Date | null {
    if (!fecha) { return null; }
    const partes = String(fecha).split('-');
    if (partes.length !== 3) { return null; }
    return new Date(+partes[0], +partes[1] - 1, +partes[2]);
  }
}
